import React from 'react'
import PropTypes from 'prop-types'
import { Grid, ListItem, ListItemText } from '@mui/material'

const SECTION_HEADER_SLOT_PROPS = { primary: { variant: 'h6', fontWeight: 500, color: 'text.secondary' } }

const AdjustServiceSectionHeader = ({ title, children }) => (
  <Grid size={12}>
    <ListItem disableGutters sx={{ display: 'flex', justifyContent: 'space-between', pr: 0, pb: 0 }}>
      <ListItemText primary={title} slotProps={SECTION_HEADER_SLOT_PROPS} />
      {children}
    </ListItem>
  </Grid>
)

AdjustServiceSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default AdjustServiceSectionHeader
